import { serializeSuperjson } from '@lib/superjson';
import type {
  CreateSnapQuoteLineBody,
  CreateSnapQuoteLineOutput,
  CreateSnapQuoteLineParams,
} from '@snap-types/actions/create-snap-quote-line';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

const [createSnapQuoteLine, _] = injectMutation<
  CreateSnapQuoteLineParams & CreateSnapQuoteLineBody,
  CreateSnapQuoteLineOutput
>(
  `${QUOTE_BUILDER_SLICE_NAME}/createSnapQuoteLine`,
  ({ siteCode, quoteUuid, partId, serviceChargeUuid }) => ({
    url: buildSnapQuoteUrl(siteCode, quoteUuid, 'quote-lines'),
    method: 'POST',
    body: serializeSuperjson({ partId, serviceChargeUuid }),
  }),
);

export { createSnapQuoteLine };
